import { Injectable } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ReCaptchaService {
  siteKey: string;

  constructor(private appConfig: AppConfigService) {
    this.loadReCaptcha();
  }

  loadReCaptcha() {
    this.appConfig.getConfig().subscribe((config) => {
      this.siteKey = config.reCaptchaApiKey;
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`;
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;

      if (!document.body.contains(script)) {
        document.head.appendChild(script);
      }
    });
  }

  public getToken(userAction: string): Observable<string> {
    const subject = new Subject<string>();
    const doExecute = () => {
      window['grecaptcha'].enterprise.execute(
        this.siteKey,
        {action: userAction}
      ).then((token: string) => {
        subject.next(token);
        subject.complete();
      }, (error: any) => {
        subject.error(error);
      });
    };
    // Wait for the grecaptcha script to finish loading before executing.
    // When called after load (e.g. on user click), ready() fires synchronously.
    const tryReady = () => {
      if (window['grecaptcha']?.enterprise) {
        window['grecaptcha'].enterprise.ready(doExecute);
      } else {
        setTimeout(tryReady, 100);
      }
    };
    tryReady();
    return subject.asObservable();
  }
}
